import React from "react";
import axios from "axios";
import {FileManagerCtrlApi, SimulationManagerCtrlApi, UtilManagerCtrlApi, UtilManagerCtrlApiFp} from "./generated/api";
import {Configuration} from "./generated";


export const MAIN_SERVER_URL = "https://blast.lange.xyz"

//export const MAIN_SERVER_URL = "localhost:8080"


export function getServerUrl() {
    let serverUrl = "";//window.location.hostname + ":" + window.location.port;
    if (window.location.hostname === "localhost" && window.location.port.startsWith("3")) {
         serverUrl =  MAIN_SERVER_URL;
    }
    return serverUrl;
}

export let serverUrl = getServerUrl();

export const config = new Configuration({});

export const axiosInstance = axios.create();

const fileManagerCtrlApi = new FileManagerCtrlApi(config, serverUrl, axiosInstance);
const simulationManagerCtrlApi = new SimulationManagerCtrlApi(config, serverUrl, axiosInstance);
const utilManagerCtrlApi = new UtilManagerCtrlApi(config, serverUrl, axiosInstance);

export default class ApiCtrl extends React.Component {

    static async getMethods(callback) {
        utilManagerCtrlApi.apiUtilMethodsGet(config).then((result) => {
            callback(result.data);
        })

    }

    static async getTiles(callback) {
        utilManagerCtrlApi.apiUtilTilesGet(config).then((result) => {
            callback(result.data);
        })

    }

    static async getHeatmap(path, callback) {
        fileManagerCtrlApi.apiFilesHeatmapGet(path,config).then((result) => {
            callback(result.data);
        })
    }

    static async getDays(path, callback) {
        fileManagerCtrlApi.apiFilesDaysGet(path,config).then((result) => {
            callback(result.data);
        })
    }

    static async getSeries(path, callback) {
        fileManagerCtrlApi.apiFilesSeriesGet(path,config).then((result) => {
            callback(result.data);
        })
    }


    static async getListOfResults(callback) {
        fileManagerCtrlApi.apiFilesGet(config).then((result) => {
            callback(result.data);
        })
    }

    static async getResult(cfg, callback) {
        fileManagerCtrlApi.apiFilesResultGet(cfg,config).then((result) => {
            callback(result.data);
        })
    }


    static async startSimulation(simulation, callback) {
        simulationManagerCtrlApi.apiRunPost(simulation, config).then((result) => {
            callback(result.data);
        })
    }

    static async reStartSimulation(code, callback) {
        simulationManagerCtrlApi.apiRunStartGet(code, config).then((result) => {
            callback(result.data);
        })
    }

    static async stopSimulation(code, callback) {
        simulationManagerCtrlApi.apiRunStopGet(code, config).then((result) => {
            callback(result.data);
        })
    }

    static async deleteSimulation(code, callback) {
        fileManagerCtrlApi.apiFilesDelete(code, config).then((result) => {
            callback(result.data);
        })
    }

    static async getListOfFiles(path, callback) {
        fileManagerCtrlApi.apiFilesLsGet(path, config).then((result) => {
            callback(result.data);
        })
    }

    static async getRawTile(path, id, callback) {
        fileManagerCtrlApi.apiFilesRawTileGet(path, id,config).then((result) => {
            callback(result.data);
        })
    }

    static async getBurstTile(path, id, callback) {
        fileManagerCtrlApi.apiFilesBurstTileGet(path, id,config).then((result) => {
            callback(result.data);
        })
    }


    static async uploadTile(packets, currentPacket, videoLength, fileName, callback) {
        utilManagerCtrlApi.apiUtilUploadTilesPost(packets, currentPacket, videoLength, fileName, config).then((result) => {
            callback(result.data);
        })
    }


}
